import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(`/mass_modification_budget/${id}/`);
};

const patch = async (id, data) => {
  return await httpClient.put(`/mass_modification_budget/${id}/`, data);
};

export { get, patch };
